import { UnitConfig } from '@src/sld/types';
import { DataPointWithValue } from '@src/types/DataPoint';
import { UnitController } from './canyon_country/devicePointsConfig';

const unitConfigWithNoData: UnitConfig = {
  unitLabel: '--',
  kw: '--',
  kvar: '--',
  soc: '--',
  racksonline: '--',
  invstatus: '--',
  runmode: '--',
};

const getUnitConfig = (unitConfigItem: UnitConfig): UnitConfig =>
  unitConfigItem !== undefined ? unitConfigItem : unitConfigWithNoData;

const checkIfDataPointsDefined = (
  dataPoints: DataPointWithValue[] | undefined,
): boolean => (dataPoints && dataPoints.length > 0 ? true : false);

const getBreakerStatusColor = (
  breakerStatus: DataPointWithValue | undefined,
): string =>
  breakerStatus ? (breakerStatus.value === 1 ? 'red' : 'green') : 'gray';

const getDataPointByPointName = (
  dataPoints: DataPointWithValue[] | undefined,
  pointName: string,
): DataPointWithValue | undefined =>
  dataPoints?.find(
    (dataPoint) =>
      dataPoint.pointName?.toLowerCase() === pointName.toLowerCase(),
  );

const getDataPointCollectionByPointNames = (
  dataPoints: DataPointWithValue[],
  pointNames: string[],
): DataPointWithValue[] => {
  const results: DataPointWithValue[] = dataPoints.filter((point) =>
    pointNames.includes(point.pointName ? point.pointName.toLowerCase() : ''),
  );

  return results;
};

const getDataPointCollectionByPointNamesAndControllerId = (
  dataPoints: DataPointWithValue[],
  pointNames: string[],
  controllerId: string,
): DataPointWithValue[] => {
  const results: DataPointWithValue[] = dataPoints.filter(
    (point) =>
      pointNames.includes(
        point.pointName ? point.pointName.toLowerCase() : '',
      ) && point.controllerId === controllerId,
  );

  return results;
};

const getDataPointsForUnitController = (
  unitControllersWithDataPointValues: UnitController[],
  unitControllerId: string,
) => {
  const filteredUnitController = unitControllersWithDataPointValues.filter(
    (unitController) => unitController.unitControllerId === unitControllerId,
  );

  return filteredUnitController.length > 0
    ? filteredUnitController[0].dataPointsWithValues
    : [];
};

export {
  getUnitConfig,
  checkIfDataPointsDefined,
  getBreakerStatusColor,
  getDataPointByPointName,
  getDataPointCollectionByPointNames,
  getDataPointCollectionByPointNamesAndControllerId,
  getDataPointsForUnitController,
};
